<section>
  <div class="pagination-layout-1">
    <button
      class="pagination-btn pagination-btn-text-size pagination-btn-text-color pagination-btn-background pagination-btn-font-weight pagination-btn-text-transform pagination-btn-border-color"
      [class.disabled]="currentPageIndex() === 0"
      (click)="onPreviousPage()"
    >
      Previous
    </button>
    <ul class="page-count-list">
      <!-- Original code commented for safety -->
      <!-- <li *ngFor="let page of paginationOptions" class="page-count-item page-count-btn-text-size page-count-btn-text-color page-count-btn-background page-count-btn-font-weight page-count-btn-text-transform page-count-btn-border-color" [ngClass]="{
          'action-item-active': currentPageIndex === page?.value,
          'non-clickable': page?.value === -1
        }" (click)="onPageClick(page.value)">
                <span>{{ page?.viewValue }}</span>
            </li> -->

      <!-- New Angular 20 Control Flow -->
      @for (page of paginationOptions(); track page.value) {
      <li
        class="page-count-item page-count-btn-text-size page-count-btn-text-color page-count-btn-background page-count-btn-font-weight page-count-btn-text-transform page-count-btn-border-color"
        [ngClass]="{
          'action-item-active': currentPageIndex() === page?.value,
          'non-clickable': page?.value === -1
        }"
        (click)="onPageClick(page.value)"
      >
        <span>{{ page?.viewValue }}</span>
      </li>
      }
    </ul>

    <button
      class="pagination-btn pagination-btn-text-size pagination-btn-text-color pagination-btn-background pagination-btn-font-weight pagination-btn-text-transform pagination-btn-border-color"
      [class.disabled]="
        paginationOptions() &&
        paginationOptions()!.length > 0 &&
        currentPageIndex() === paginationOptions()![paginationOptions()!.length - 1]?.value
      "
      (click)="onNextPage()"
    >
      Next
    </button>
  </div>
</section>
